// extracted by mini-css-extract-plugin
export var headline2 = "Headline2-module--headline2--d1BdM";